import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const educationFund: AnswerPathTreeNode = {
  path: 'educationFund',
  children: [{ path: 'educationCost', nodeId: NodeIds.childrenEducationCost }],
};
